import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Link,
  Typography as MuiTypography,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { NavLink, useParams } from "react-router-dom";

import EvaluationForm from "./EvaluationForm";
import { useApp } from "../../../../AppProvider";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Typography = styled(MuiTypography)(spacing);

function NewAcquisitionAndOpportunityManagement() {
  let { id } = useParams();
  const [selectedOpportunity, setSelectedOpportunity] = useState(0);
  const { currentUser } = useApp();

  return (
    <React.Fragment>
      <Helmet title="Water Acquisitions & Opportunities Log" />
      <Typography variant="h3" gutterBottom display="inline">
        New Acquisition & Opportunity
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to={currentUser?.home || "/"}>
          Dashboard
        </Link>
        <Link
          component={NavLink}
          exact
          to="/water-acquisition-tool/acquisitions-and-opportunities"
        >
          Summary of Acquisition Opportunities
        </Link>
        <Typography>New Acquisition & Opportunity</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <EvaluationForm
        preSelectedSource={id}
        selectedOpportunity={selectedOpportunity}
        setSelectedOpportunity={setSelectedOpportunity}
      />
    </React.Fragment>
  );
}

export default NewAcquisitionAndOpportunityManagement;
